import { render, staticRenderFns } from "./FEArea1.vue?vue&type=template&id=17bf7bc5&scoped=true"
import script from "./FEArea1.vue?vue&type=script&lang=js"
export * from "./FEArea1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bf7bc5",
  null
  
)

export default component.exports